import React, {Fragment, useState} from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {Dialog, Button} from '@material-ui/core';
import {RingLoader} from "react-spinners";
import {CheckIcon, CloseIcon, LightBulbIcon} from "../../../elements/svgIcons";
import {isMobileBrowser} from "../../../vendors/utils/common";

interface Props {
    icon?: string | undefined,
    title?: any,
    description?: any,
    className?: string | undefined,
    inProcess?: boolean,
    open?: boolean,
    cancelable: {
        buttonTitle: string,
        action?: any
    } | undefined,
    submit?: {
        buttonTitle: string,
        action: any,
        disabled?: boolean
    } | undefined,
    iconIsVisible?: boolean,
    // Form fields belong here rather than inside `description`, which renders in a <p>.
    children?: React.ReactNode
}

const icons: {
    [key: string]: any
} = {
    times: <FontAwesomeIcon
        icon={['fas', 'times']}
        className="d-flex align-self-center display-3"
    />,
    lightbulb: <LightBulbIcon className="d-flex align-self-center"/>
};

const QuestionModal = (props: Props) => {
    const {icon, title, description, open = false, cancelable, submit, className, inProcess, iconIsVisible = false, children} = props;
    const [modal, setModal] = useState(open);
    const toggle = () => setModal(!modal);

    return (
        <Fragment>
            <Dialog className={`${className} question-modal`} open={modal} onClose={cancelable?.action || toggle}>
                <CloseIcon onClick={cancelable?.action} className='modal-close'/>
                {<div className="modal-container text-center px-3 py-4 p-md-5">
                    <div className={`avatar-icon-wrapper rounded-circle m-0`}>
                        {!inProcess && icon && <div
                            className="d-inline-flex position-relative justify-content-center p-0 rounded-circle avatar-icon bg-neutral-purple text-purple m-0">
                            {icons[icon] || <div className={icon}/>}
                        </div>}
                        {inProcess &&
                        <div className={'d-inline-block mx-auto'}><RingLoader color={'var(--primary)'} loading={true}/>
                        </div>}
                    </div>
                    {title && <h4 className="c-m-title modal-title font-weight-bold mt-4 mb-4">{title}</h4>}
                    {description && <p className="c-m-description mb-0 mt-4 text-gray">{description}</p>}
                    {children && <div className="mt-4 text-left">{children}</div>}
                    <div className="pt-4 text-nowrap">
                        {submit && <Button
                            onClick={submit.action}
                            variant="contained"
                            color='primary'
                            size={isMobileBrowser() ? 'small' : 'medium'}
                            disabled={inProcess || submit.disabled}
                            className="mx-2 font-weight-normal">
                            {iconIsVisible &&
                            <span className="btn-wrapper--icon">
                                <CheckIcon style={{fontSize: '.857rem'}}/>
                            </span>}
                            <span className="btn-wrapper--label">{submit.buttonTitle}</span>
                        </Button>}
                        {cancelable && <Button
                            onClick={cancelable.action}
                            variant="outlined"
                            size={isMobileBrowser() ? 'small' : 'medium'}
                            disabled={inProcess}
                            className="mx-2 text-black-50 font-weight-normal">
                            <span className="btn-wrapper--label">{cancelable.buttonTitle || 'Never Mind'}</span>
                        </Button>}
                    </div>
                </div>}
            </Dialog>
        </Fragment>
    );
};

export default QuestionModal
